
import { Component, Prop, Vue, Watch, Inject } from "vue-property-decorator";
import Nav from "@/components/semantics/TempNavigation.vue";
import TitleHeader from "@/components/base/table/header/LeftLineHeader.vue";
import { mapState } from "vuex";
import { TitleConfig, RouteConfig } from "@/config";
import { State, Getter, Action, Mutation } from "vuex-class";
import { dispatchLogOut } from "@/store/dispatches";
import {
  deepClone,
  getStorage,
  getParentArea,
  getAreaDepartmentByLastCode,
} from "@/common/utils";
@Component({
  name: "TempNavHeader",
  components: {
    Nav,
    TitleHeader,
  },
})
export default class TempNavHeader extends Vue {
  @Getter("cityId") private cityId: any;
  @Action("account/getAuthernData") private getAuthern: any;
  @Action("addPopularCitiy") private addPopularCitiy: any;
  @Action("getHotCity") private getHotCityData: any;
  @State("basic") private basic: any;
  @Getter("provinceId") private provinceId: any;
  @Getter("city") private city: any;
  @Getter("account") private account: any;
  @Getter("phone") private phone: any;
  @Getter("company") private userName: any;
  @Getter("role") private role: any;
  @Mutation("setCity") private setCity: any;
  @State("directCityList") private directCityList: any;
  currentProvince: any = "";
  currentCities: any = [];
  company: any = "";
  @Watch("city", {
    immediate: true,
    deep: true,
  })
  handleCityChange(newValue: any, oldValue: any) {}
  is_login = false;
  pcm: any = TitleConfig;
  lightenList: any = ["/temp/home"];
  enHeaderArr: Array<any> = [];
  enArr: Array<any> = [];
  activeEn = 0;
  activeProvince = 0;
  provinceArr: Array<any> = [];
  cityArr: Array<any> = [];
  areaOption = this.$root.$data.areaOption;
  hotCityArr: Array<any> = [];
  visible = false;
  @Watch("visible", { immediate: true })
  handleVisibleChange(newValue: any, oldValue: any) {
    if (newValue) {
      this.getHotCity();
    }
  }
  async created() {
    this.getData();
    this.currentProvince = this.provinceId;
    if (this.currentProvince) {
      this.selectProvince(this.currentProvince);
    }
  }
  async getData() {
    this.getBasicData();
    this.getHotCity();
    // this.getCityData();
  }
  async getBasicData() {
    const data = await this.getAuthern({ idNature: this.role });

    if (data) {
      const { unitName } = data;
      this.company = unitName;
    }
  }
  async selectProvince(provinceId: any) {
    this.currentProvince = provinceId;

    const tempCity = getAreaDepartmentByLastCode(this.areaOption, provinceId);
    const { children } = tempCity;
    this.currentCities = children || [];
  }
  async selectCity(item: any) {
    this.visible = false;
    let { parent, value: code, label: name } = item;
    let provinceId = "";
    if (parent) {
      provinceId = parent.value;
    } else {
      const provinceItem: any = getParentArea(this.areaOption, code);
      provinceId = provinceItem ? provinceItem.value : provinceItem;
    }
    this.setCity({ provinceId, id: code, name });
    //this.addPopularCitiy({ code, name });
    // location.reload();
  }
  clickEnOption(index: any) {
    this.activeEn = index;
    switch (index) {
      case 0:
        this.getHotCity();
        break;
      default:
        this.getEnCity();
        break;
    }
  }
  async getHotCity() {
    const res = await this.getHotCityData();
    if (res) {
      this.cityArr = res
        .map(({ value: { code: value, name: label } }: any) => {
          const parent: any = getParentArea(this.areaOption, value);
          return {
            value,
            label,
            parent,
          };
        })
        .filter((province: any) => {
          const directCityLabelList = [
            "天津市辖区",
            "北京市辖区",
            "重庆市辖区",
            "上海市辖区",
            "中央",
          ];
          return !directCityLabelList.includes(province.label);
        });
    }
  }
  getEnCity() {
    const cityData = deepClone(this.areaOption);
    const en = this.enArr[this.activeEn - 1];
    const provinceArr = cityData.filter(({ initials }: any) => {
      return initials === en;
    });

    this.provinceArr = provinceArr;
  }
  toUser() {
    if (this.role) {
      this.$router.push({ path: `/${this.role}/home` });
    }
  }
  toLogin() {
    const options: any = this.$route.query;
    this.$router.push({
      name: "Login",
      params: {
        beforePath: this.$route.path,
        beforeOption: options,
      },
    });
  }
  toRegist() {
    this.$router.push({ path: "/regist" });
  }
  logOut() {
    const options: any = this.$route.query;
    this.$router.push({
      name: "Login",
      params: {
        beforePath: this.$route.path,
        beforeOption: options,
      },
    });
    dispatchLogOut();
  }
  handleClick() {}
  @Watch("role")
  handleRoleChange(newValue: any, oldValue: any) {}
}
